import { useEffect, useState } from "react";
import api from "./api";

const FEATURED_GAME_NAMES = ["cash frenzy", "cash machine"];

export function orderLiveGames(games) {
  const live = games.filter((game) => game.status === "live");
  const featured = FEATURED_GAME_NAMES.flatMap((name) =>
    live.filter((game) => game.name.trim().toLowerCase() === name)
  );
  const featuredIds = new Set(featured.map((game) => game.id));
  return [...featured, ...live.filter((game) => !featuredIds.has(game.id))];
}

export default function useLiveGames() {
  const [games, setGames] = useState([]);
  useEffect(() => {
    let active = true;
    let pending = false;
    const refresh = async () => {
      if (pending || document.visibilityState === "hidden") return;
      pending = true;
      try {
        const { data } = await api.get("/games?status_filter=live");
        if (active) setGames(orderLiveGames(data));
      } catch {
        // Preserve the last catalog during a temporary connection failure.
      } finally {
        pending = false;
      }
    };
    refresh();
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    const timer = window.setInterval(refresh, 60000);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, []);
  return games;
}
